import { PyramidSettings } from 'src/app/models/pyramid.interface';
import { PyramidPaths } from 'src/app/models/pyramid.enum';

export const pyramidRobotEnvironmentBacteriaSettings: PyramidSettings = {
  title: 'Robotmjölkning och miljöbakterier',
  path: PyramidPaths.RobotEnvironmentBacteria,
};
